"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExponent = exports.getValue = exports.formatPercentage = exports.formatCurrency = exports.formatPlainNumber = exports.formatNumberWithExponent = exports.getOnlyNumbers = void 0;
const LOCALE = 'pt-BR';

const getOnlyNumbers = value => {
  const numbers = String(value).replace(/\D+/g, '');
  return Number(numbers);
};

exports.getOnlyNumbers = getOnlyNumbers;

const formatNumberWithExponent = (value, compactDisplay = 'short') => new Intl.NumberFormat(LOCALE, {
  style: 'decimal',
  notation: 'compact',
  compactDisplay,
  minimumFractionDigits: 0,
  maximumFractionDigits: 1
}).format(getOnlyNumbers(value));

exports.formatNumberWithExponent = formatNumberWithExponent;

const formatPlainNumber = value => {
  if (!value) {
    return '';
  }

  return new Intl.NumberFormat(LOCALE, {
    style: 'decimal'
  }).format(getOnlyNumbers(value));
};

exports.formatPlainNumber = formatPlainNumber;

const formatCurrency = (value, hasExpoent = false) => new Intl.NumberFormat(LOCALE, {
  style: 'currency',
  currency: 'BRL',
  ...(hasExpoent ? {
    notation: 'compact',
    compactDisplay: 'short'
  } : {})
}).format(value);

exports.formatCurrency = formatCurrency;

const formatPercentage = value => new Intl.NumberFormat(LOCALE, {
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
}).format(value / 100);

exports.formatPercentage = formatPercentage;

const getValue = value => formatNumberWithExponent(value).split(' ')[0];

exports.getValue = getValue;

const getExponent = value => formatNumberWithExponent(value).split(' ')[1];

exports.getExponent = getExponent;